import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { AREAS, IMAGES } from "../../data";
import { Reveal } from "./Reveal";

export const ServiceArea = () => (
  <section
    className="relative overflow-hidden py-24 sm:py-32"
    data-testid="area-section"
  >
    <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-white/10">
          <img
            src={IMAGES.naples}
            alt="Napoli, zona servita da ELETTRIKPRO"
            className="aspect-[4/3] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#020813] via-[#020813]/30 to-transparent" />
          <div className="absolute bottom-5 left-5 flex items-center gap-2 rounded-full bg-[#FFC400] px-4 py-2 text-sm font-bold text-[#0B1F3A]">
            <MapPin className="h-4 w-4" /> Napoli e provincia
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#FFC400]">
            / Zona servita
          </p>
          <h2 className="font-display text-3xl font-extrabold tracking-tighter text-white sm:text-5xl">
            Elettricista Napoli e provincia
          </h2>
          <p className="mt-5 max-w-lg text-white/70">
            ELETTRIKPRO offre servizi elettrici professionali in tutta Napoli e
            provincia, garantendo interventi rapidi per abitazioni, uffici e
            attività commerciali.
          </p>
        </Reveal>

        <div className="mt-8 flex flex-wrap gap-3">
          {AREAS.map((a, i) => (
            <Reveal key={a} delay={i * 0.04}>
              <motion.span
                whileHover={{ y: -3 }}
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-medium text-white/80 transition-colors hover:border-[#FFC400]/50 hover:text-[#FFC400]"
                data-testid={`area-${i}`}
              >
                <MapPin className="h-3.5 w-3.5 text-[#FFC400]" />
                {a}
              </motion.span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ServiceArea;
